import { useEffect } from 'react'
import { localStorage } from '@muse-web/storages'
import { SESSION_TTL_SECONDS } from '@core/http-client'

import { TAB_HIDDEN_AT_KEY } from '../constants/storageKeys'

import { rotateSession } from '../helpers/touchSession'
import { sendEvent } from '../helpers/sendEvent'

const SESSION_STORAGE = 'sessionStorage'

const isHiddenLongerThanSession = (hiddenAt: unknown) => {
    const hiddenAtMs = typeof hiddenAt === 'string' ? Number(hiddenAt) : Number.NaN

    return Date.now() - hiddenAtMs > SESSION_TTL_SECONDS * 1000
}

export const useFocusTracking = () => {
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                sendEvent({ name: 'ac_tab_hidden', payload: {} }, true)
                localStorage.set(TAB_HIDDEN_AT_KEY, String(Date.now()), SESSION_STORAGE)
                return
            }

            const hiddenAt = localStorage.get(TAB_HIDDEN_AT_KEY, SESSION_STORAGE)
            if (hiddenAt) {
                localStorage.remove(TAB_HIDDEN_AT_KEY, SESSION_STORAGE)

                if (isHiddenLongerThanSession(hiddenAt)) {
                    rotateSession(Number(hiddenAt))
                }

                sendEvent({ name: 'ac_tab_visible', payload: {} })
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    }, [])
}
